var map = {
	"./18PW.png": 20863,
	"./19PW.png": 4168,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusGold/18PW.png": 20863,
	"components/Catalog/PW/img/inserDoor/ks/ksPlusGold/19PW.png": 4168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13349;